import React from 'react'

import posthog from 'posthog-js'

export const NOTIFICATION_TYPES = {
  info: 'info',
  success: 'success',
  warning: 'warning',
  error: 'danger',
  primary: 'primary',
}

export const calendlyTokenLink = 'https://calendly.com/integrations'

export const calendlyEventsLink = 'https://calendly.com/event_types/user/me'
export const getPrimaryVideoLink = (customFlow) => {
  if (customFlow) {
    return 'https://www.youtube.com/watch?v=lkQ5LokAt94&list=PLuD5L2_Fh7vXAAAnkRWWYXLbFKoASIggg&index=12'
  }
  return 'https://youtu.be/IdhwKCqYk9I'
}

export const getPlanVideo = (setting) => {
  if (window.location.href.includes('charge_id')) {
    switch (setting.plan) {
      case 'pro':
        return VIDEO_LINKS.PRO_PLAN
      case 'premium':
        return VIDEO_LINKS.PREMIUM_PLAN
      case 'enterprise':
        return VIDEO_LINKS.ENTERPRISE_PLAN
    }
  }
  return ''
}

export const VIDEO_LINKS = {
  PRO_PLAN: 'https://www.youtube.com/embed/exrtkLIQeIo',
  PREMIUM_PLAN: 'https://www.youtube.com/embed/CHSx7RnSr7g',
  ENTERPRISE_PLAN: 'https://www.youtube.com/embed/HNzOHaXLrB0',
}

const help_desk_url = 'https://help.sidepanda.com'

export const LEARN_MORE_LINK = {
  GROUP_APPT: `${help_desk_url}/en/article/group-appointmentsmax-number-of-invitees-in-a-slot-1oy3ob5/`,

  EMAIL_REMINDER: `${help_desk_url}/en/articles/8389712-can-i-send-email-text-reminders-using-appointo`,
  AVAILABILITY: `${help_desk_url}/en/articles/8389638-i-want-to-set-a-different-time-for-a-certain-day-how-can-i-do-that`,
  BLOCK_DATES: `${help_desk_url}/en/articles/8389636-i-want-to-block-off-certain-days-times-how-can-i-do-that`,
  CUSTOM_QUESTION: `${help_desk_url}/en/articles/8389634-can-i-create-a-form-or-ask-questions-to-my-customers-before-booking`,
  MANUAL_BOOKING: `${help_desk_url}/en/articles/8389647-i-want-to-create-a-manual-booking-for-my-customer`,
  CALENDAR_SETTINGS: `${help_desk_url}/en/articles/8389660-i-want-to-make-changes-to-the-calendar-invite-how-can-i-do-that`,
  PRO_PLAN: `${help_desk_url}/en/article/pro-plan-appointo-dy2sfn/`,
  PREMIUM_PLAN: `${help_desk_url}/en/article/premium-plan-appointo-1b8mjqe/`,
  ADVANCED_PLAN: `${help_desk_url}/en/article/advanced-plan-appointo-1kojnew/`,
  SUBSCRIPTION: `${help_desk_url}/en/articles/8389696-i-want-to-provide-class-pass-to-my-customer-or-x-number-of-bookings-every-y-days`,
}

export const CRISP_SLUG = {
  GROUP_APPT: '1oy3ob5',
  BLOCK_DATES: '3ck9fi',
  AVAILABILITY: 'jyfkuk',
  WAITLIST: '1gec7e8',
  SURGE_PRICING: '1y6qoih',
}

export const MONTH_DAY_MAPPING = {
  1: { startDate: '2021-01-01', endDate: '2021-01-31' },

  2: { startDate: '2021-02-01', endDate: '2021-02-28' },

  3: { startDate: '2021-03-01', endDate: '2021-03-31' },

  4: { startDate: '2021-04-01', endDate: '2021-04-30' },

  5: { startDate: '2021-05-01', endDate: '2021-05-31' },

  6: { startDate: '2021-06-01', endDate: '2021-06-30' },

  7: { startDate: '2021-07-01', endDate: '2021-07-31' },

  8: { startDate: '2021-08-01', endDate: '2021-08-31' },

  9: { startDate: '2021-09-01', endDate: '2021-09-30' },

  10: { startDate: '2021-10-01', endDate: '2021-10-31' },

  11: { startDate: '2021-11-01', endDate: '2021-11-30' },

  12: { startDate: '2020-12-01', endDate: '2020-12-31' },
}

export const generateTimeOptions = (duration) => {
  var times = [] // time array
  var tt = 0 // start time
  var ap = ['AM', 'PM'] // AM-PM

  //loop to increment the time and push results in array
  for (var i = 0; tt < 24 * 60; i++) {
    var hh = Math.floor(tt / 60) // getting hours of day in 0-24 format
    var mm = tt % 60 // getting minutes of the hour in 0-55 format
    times[i] =
      ('0' + (hh % 12)).slice(-2) +
      ':' +
      ('0' + mm).slice(-2) +
      ap[Math.floor(hh / 12)] // pushing data in array in [00:00 - 12:00 AM/PM format]
    tt = tt + parseInt(duration, 10)
  }

  return times.map((t) => {
    switch (t) {
      case '00:00PM':
        return { value: t, label: '12:00PM' }

      case '00:15PM':
        return { value: t, label: '12:15PM' }

      case '00:30PM':
        return { value: t, label: '12:30PM' }

      case '00:45PM':
        return { value: t, label: '12:45PM' }

      default:
        return { value: t, label: t }
    }
  })
}

export const DefaultTimeSlots = [
  {
    weekday: 'monday',
    slots: [{ start_time: '09:00AM', end_time: '05:00PM' }],
  },
  {
    weekday: 'tuesday',
    slots: [{ start_time: '09:00AM', end_time: '05:00PM' }],
  },
  {
    weekday: 'wednesday',
    slots: [{ start_time: '09:00AM', end_time: '05:00PM' }],
  },
  {
    weekday: 'thursday',
    slots: [{ start_time: '09:00AM', end_time: '05:00PM' }],
  },
  {
    weekday: 'friday',
    slots: [{ start_time: '09:00AM', end_time: '05:00PM' }],
  },
]

export const DefaultTimeSlot = { start_time: '09:00AM', end_time: '05:00PM' }

export const selectOptions = [
  {
    label: 'Pacific Standard Time (PST)',
    value: 'America/Los_Angeles',
  },
  {
    label: 'Eastern Time (ET)',
    value: 'America/New_York',
  },
  {
    label: 'Central Time (US & Canada)',
    value: 'Central Time (US & Canada)',
  },
  {
    label: 'Mountain Time (US & Canada)',
    value: 'Mountain Time (US & Canada)',
  },
  {
    label: 'Alaska Timezone',
    value: 'America/Juneau',
  },
  {
    label: 'Central Standard Time',
    value: 'Saskatchewan',
  },
  {
    label: 'Guam Timezone',
    value: 'Pacific/Guam',
  },
  {
    label: 'Newfoundland Time Zone',
    value: 'Newfoundland',
  },
  {
    label: 'Atlantic Time (Canada)',
    value: 'Atlantic Time (Canada)',
  },
  {
    label: 'Arizona Timezone',
    value: 'America/Phoenix',
  },
  {
    label: 'Hawaii Standard Time',
    value: 'Hawaii',
  },
  {
    label: 'UK,Ireland,Lisbon Time',
    value: 'Europe/London',
  },
  {
    label: 'South African Standard Time',
    value: 'Africa/Johannesburg',
  },
  {
    label: 'Central European Time(CET) ',
    value: 'CET',
  },
  {
    label: 'Eastern European Time (EET)',
    value: 'EET',
  },
  {
    label: 'Greenland Timezone',
    value: 'America/Godthab',
  },
  {
    label: 'New Zealand Standard Time',
    value: 'Pacific/Auckland',
  },
  {
    label: 'Arabian Standard Time',
    value: 'Asia/Kuwait',
  },
  {
    label: 'Ecuador Timezone',
    value: 'America/Lima',
  },
  {
    label: 'Panama Timezone',
    value: 'EST',
  },
  {
    label: 'Pakistan Standard Time (PKT)',
    value: 'Asia/Karachi',
  },
  {
    label: 'Indian Standard Time (IST)',
    value: 'Asia/Kolkata',
  },
  {
    label: 'Japan Standard Time',
    value: 'Asia/Tokyo',
  },
  {
    label: 'Singapore Time',
    value: 'Singapore',
  },
  {
    label: 'UAE Standard Time',
    value: 'Asia/Dubai',
  },
  {
    label: 'Coordinated Universal Time (UTC)',
    value: 'UTC',
  },
  {
    label: 'Australia/Adelaide',
    value: 'Australia/Adelaide',
  },
  {
    label: 'Hong Kong Time',
    value: 'Asia/Hong_Kong',
  },
  {
    label: 'Asia/Bangkok',
    value: 'Asia/Bangkok',
  },
  {
    label: 'Australia/Brisbane',
    value: 'Australia/Brisbane',
  },
  {
    label: 'Australia/Darwin',
    value: 'Australia/Darwin',
  },
  {
    label: 'Australia/Perth',
    value: 'Australia/Perth',
  },
  {
    label: 'Australia/Sydney',
    value: 'Australia/Sydney',
  },
  {
    label: 'Chile Standard Time',
    value: 'America/Santiago',
  },
  {
    label: 'America/Sao_Paulo',
    value: 'America/Sao_Paulo',
  },
  {
    label: 'Atlantic Standard Time',
    value: 'America/Barbados',
  },
  {
    label: 'Malaysia Time Zone',
    value: 'Asia/Kuala_Lumpur',
  },
  {
    label: 'Israel Standard Time',
    value: 'Asia/Jerusalem',
  },
]

export const locationOptions = [
  {
    label: 'None',
    value: null,
  },
  {
    label: 'Address',
    value: 'address',
  },
  {
    label: 'Phone',
    value: 'phone',
  },
  {
    label: 'Zoom',
    value: 'zoom',
  },
  {
    label: 'Google Meet',
    value: 'google_meet',
  },
  {
    label: 'Microsoft Teams',
    value: 'microsoft_teams',
  },
]

export const comparision = [
  {
    name: 'Custom Flow',
    items: [
      'Email Notifications',
      'Rescheduling & Cancellation',
      'Block Certain Dates',
      'Group Appointments',
      'Customisations',
      'Calendar Integration',
      'Zoom/Google Meet Link',
      'Custom Note for customers',
      'Custom Questions',
    ],
    subheader: 'Manage Appointment directly through Shopify',
    key: 'custom',
  },
  {
    name: 'Calendly Flow',
    items: [
      'Email Notifications',
      'Rescheduling & Cancellation',
      'Block Certain Dates',
      'Group Appointments',
      'Customisations',
      'Calendar Integration',
      'Email & Text Reminiders',
      'Zoom Integration',
    ],
    subheader: 'Additional charges may apply due to calendly subscription',
    key: 'calendly',
  },
]

export const EmailSettingsOptions = [
  { label: 'Confirmation Email', value: 'confirmation' },
  { label: 'Rescheduling Email', value: 'rescheduling' },
  { label: 'Cancellation Email', value: 'cancellation' },
  { label: 'Conflict Email', value: 'conflict' },
  { label: 'Reminder Email', value: 'reminder' },
  { label: 'Workflow Email', value: 'workflow' },
  { label: 'Waitlist Pending Email', value: 'waitlist_request' },
  { label: 'Waitlist Reject Email', value: 'waitlist_cancelled' },
]

export const CalendarSettingsOptions = [
  { label: 'Single Booking Calendar Invite', value: 'single' },
  { label: 'Group Booking Calendar Invite', value: 'group' },
]

export const EmailSettingsMap = {
  confirmation: {
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{appointment_time}} corresponds to the Product Name & Appointment Time sent in the mail. Please make sure those are set properly',
    },
    appointment: { type: 'half', label: 'Appointment' },
    duration: { type: 'half', label: 'Duration' },
    minutes: { type: 'half', label: 'Minutes' },
    meeting_detail: { type: 'half', label: 'Meeting Detail' },
    note: { type: 'half', label: 'Note' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    location: { type: 'half', label: 'Location' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    cancellation_link: { type: 'half', label: 'Cancellation Link' },
    reschedule_link: { type: 'half', label: 'Reschedule Link' },
    customer_portal_link: { type: 'half', label: 'Customer Portal Link' },
    order_name: { type: 'half', label: 'Order Name' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  rescheduling: {
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{previous_appointment_time}} & {{current_appointment_time}} corresponds to the Product Name & Previous Appointment Time & Current Appointment Time sent in the mail. Please make sure those are set properly',
    },
    appointment: { type: 'half', label: 'Appointment', text: '' },
    duration: { type: 'half', label: 'Duration' },
    minutes: { type: 'half', label: 'Minutes' },
    meeting_detail: { type: 'half', label: 'Meeting Detail' },
    note: { type: 'half', label: 'Note' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    location: { type: 'half', label: 'Location' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    reason: { type: 'half', label: 'Reason for rescheduling' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  cancellation: {
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{appointment_time}} corresponds to the Product Name & Appointment Time sent in the mail. Please make sure those are set properly',
    },
    appointment: { type: 'half', label: 'Appointment' },
    duration: { type: 'half', label: 'Duration' },
    minutes: { type: 'half', label: 'Minutes' },
    meeting_detail: { type: 'half', label: 'Meeting Detail' },
    note: { type: 'half', label: 'Note' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    location: { type: 'half', label: 'Location' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    reason: { type: 'half', label: 'Reason for cancellation' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  conflict: {
    subject: { type: 'full', label: 'Subject' },
    appointment: { type: 'half', label: 'Appointment' },
    book: { type: 'half', label: 'Book Appointment' },
    single_use: { type: 'full', label: 'Disclaimer Text' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    location: { type: 'half', label: 'Location' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  reminder: {
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{appointment_time}} corresponds to the Product Name & Appointment Time sent in the mail. Please make sure those are set properly',
    },
    appointment: { type: 'half', label: 'Appointment' },
    duration: { type: 'half', label: 'Duration' },
    minutes: { type: 'half', label: 'Minutes' },
    meeting_detail: { type: 'half', label: 'Meeting Detail' },
    note: { type: 'half', label: 'Note' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    location: { type: 'half', label: 'Location' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    reconfirm_booking_btn: { type: 'full', label: 'Confirm Booking Button' },
    reconfirm_booking_title: { type: 'full', label: 'Confirm Booking Title' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  workflow: {
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  waitlist_request: {
    appointment: { type: 'half', label: 'Subject' },
    duration: { type: 'half', label: 'Duration' },
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{appointment_time}} corresponds to the Product Name & Appointment Time sent in the mail. Please make sure those are set properly',
    },
    minutes: { type: 'half', label: 'Minutes' },
    order_name: { type: 'half', label: 'Order Name' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    phone_number: { type: 'half', label: 'Phone Number' },
    contact_us: { type: 'full', label: 'Contact Us' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    address: { type: 'half', label: 'Address' },
    cancellation_link: { type: 'half', label: 'Cancellation Link' },
    reschedule_link: { type: 'half', label: 'Reschedule Link' },
    customer_portal_link: { type: 'half', label: 'Customer Portal Link' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
  waitlist_cancelled: {
    appointment: { type: 'half', label: 'Subject' },
    duration: { type: 'half', label: 'Duration' },
    confirm_text: {
      type: 'full',
      label: 'Confirmation Text',
      text: '{{product_name}} & {{appointment_time}} corresponds to the Product Name & Appointment Time sent in the mail. Please make sure those are set properly',
    },
    minutes: { type: 'half', label: 'Minutes' },
    meeting_detail: { type: 'half', label: 'Meeting Detail' },
    note: { type: 'half', label: 'Note' },
    order_name: { type: 'half', label: 'Order Name' },
    appointment_summary: { type: 'half', label: 'Appointment Summary' },
    customer_information: { type: 'half', label: 'Customer Information' },
    customer_name: { type: 'half', label: 'Customer Name' },
    email_address: { type: 'half', label: 'Email Address' },
    address: { type: 'half', label: 'Address' },
    cancellation_link: { type: 'half', label: 'Cancellation Link' },
    reschedule_link: { type: 'half', label: 'Reschedule Link' },
    phone_number: { type: 'half', label: 'Phone Number' },
    questions_and_answers: { type: 'half', label: 'Questions & Answers' },
    contact_us: { type: 'full', label: 'Contact Us' },
    customer_portal_link: { type: 'half', label: 'Customer Portal Link' },
    reply_email: { type: 'half', label: 'Contact Us Email' },
  },
}

export const ShowContactButton = [
  'pedall-bike.myshopify.com',
  'cheffboris.myshopify.com',
  'bugs-vintage-and-thrift.myshopify.com',
  'coastalsurgecrafts.myshopify.com',
  'east-harlem-tax-service.myshopify.com',
  'her-kollxtion.myshopify.com',
  'the-man-camp.myshopify.com',
  'hue-la-la.myshopify.com',
  'ar-jr-glass-hardware-wholesale.myshopify.com',
  'joealhaddad.myshopify.com',
  'unfold-preloved.myshopify.com',
  'ecco-restaurant.myshopify.com',
  'kl-diamonds.myshopify.com',
  'coaching-with-ladi.myshopify.com',
  'alice-agnes.myshopify.com',
  'bbqikpro.myshopify.com',
  'us-thenorthamericanguitar.myshopify.com',
  'joshuas-3d-supplies.myshopify.com',
  'the-food-truck-pros.myshopify.com',
  'entrepreneurbusinesscoach.myshopify.com',
  '30-5plan.myshopify.com',
  'ovb-deutschland.myshopify.com',
  'virtu360.myshopify.com',
  'yl-mama-millennial.myshopify.com',
  'solibre.myshopify.com',
  'mtk-australia-2021.myshopify.com',
  'digimentori-fi.myshopify.com',
  'karuptcustomz.myshopify.com',
  'healthy-leaf-organics.myshopify.com',
  'millennialmapping.myshopify.com',
  'percotest.myshopify.com',
  'apfit-coaching.myshopify.com',
  'oshun-spiritual-cleansing.myshopify.com',
  'educatio-france.myshopify.com',
  'jordan-steinberg-fitness.myshopify.com',
  'kendra-kreations-styling.myshopify.com',
  'ts-creative-closet.myshopify.com',
  'buildingbodieswitht.myshopify.com',
  'kalani-grillz.myshopify.com',
  'mdshowroom.myshopify.com',
  'sivaramtest2.myshopify.com',
  'torontoplantgirl.myshopify.com',
  'i-been-pretty.myshopify.com',
  'bellemerenewyork.myshopify.com',
]

export const localesOptions = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'German' },
  { value: 'es', label: 'Spanish' },
  { value: 'pt', label: 'Portuguese' },
]

export const supportedLocales = [
  { label: '🇦🇪 Arabic (العربية)', value: 'ar' },
  { label: '🇮🇩 Indonesian (ID)', value: 'id' },
  { label: '🇮🇹 Italian (Italiano)', value: 'it' },
  { label: '🇷🇴 Romanian (Română)', value: 'ro' },
  { label: '🇸🇪 Swedish (Svenska)', value: 'sv' },
  { label: '🇮🇸 Icelandic (IS)', value: 'is' },
  { label: '🇷🇺 Russian (Русский)', value: 'ru' },
  { label: '🇺🇸 English (US)', value: 'en' },
  { label: '🇩🇪 German (Deutsch)', value: 'de' },
  { label: '🇯🇵 Japanese (日本語)', value: 'ja' },
  { label: '🇳🇱 Dutch (Nederlands)', value: 'nl' },
  { label: '🇸🇰 Slovak (Slovenčina)', value: 'sk' },
  { label: '🇪🇪 Estonian (Eesti keel)', value: 'et-ee' },
  { label: '🇹🇭 Thai (ไทย)', value: 'th' },
  { label: '🇨🇿 Czech (Čeština)', value: 'cs' },
  { label: '🇪🇸 Spanish (Español)', value: 'es' },
  { label: '🇫🇷 French (Français)', value: 'fr' },
  { label: '🇧🇬 Bulgarian (Български)', value: 'bg' },
  { label: '🇪🇸 Catalan (CA)', value: 'ca' },
  { label: '🇱🇻 Latvian (Latviešu)', value: 'lv' },
  { label: '🇩🇰 Danish (Dansk)', value: 'da' },
  { label: '🇸🇮 Slovenian (Slovenščina)', value: 'sl' },
  { label: '🇻🇳 Vietnamese (Tiếng Việt)', value: 'vi' },
  { label: '🇫🇮 Finnish (Suomi)', value: 'fi' },
  { label: '🇲🇾 Malay (MS)', value: 'ms' },
  { label: '🇳🇴 Norwegian (Bokmål)', value: 'no' },
  { label: '🇵🇹 Portuguese (Português)', value: 'pt' },
  { label: '🇵🇱 Polish (Polski)', value: 'pl' },
  { label: '🇹🇼 Chinese (Taiwan) (中文 (台灣))', value: 'zh-tw' },
]

export const customWidgetTextLabels = {
  selectTime: 'Select Time',
  selectDate: 'Select Date',
  selectSlot: 'Select one time slot from the available slots',
  chooseDate: 'Please choose a date',
  bookingConfirmed: 'Appointment Booking Confirmed',
  addToCart: 'Add to Cart',
  updateInCart: 'Update In Cart',
  checkout: 'Checkout',
  allSelectedBookings: 'All Selected Bookings',
  chooseVariant: 'Choose a Variant',
  availableSlots: 'Available Slots',
  loading: 'Loading',
  poweredBy: 'Powered By',
  redirectingToCheckout: 'Redirecting to Checkout',
  confirmationText: 'Added to Cart- Confirmation will be sent post purchase',
  removeBooking: 'Remove Booking',
  bookingRemoved: 'Booking removed from the cart',
  bookingConfirmation: 'Booking Confirmation',
  back: 'Back',
  bookNow: 'Book Now',
  bookViaCalendly: 'Book Via Calendly',
  calendlyBookingError: 'Calendly Error...Click on the above link to book',
  confirm: 'Confirm',
  dateTime: 'Date & Time',
  january: 'January',
  february: 'February',
  march: 'March',
  april: 'April',
  may: 'May',
  june: 'June',
  july: 'July',
  august: 'August',
  september: 'September',
  october: 'October',
  november: 'November',
  december: 'December',
  sunday: 'sunday',
  monday: 'monday',
  tuesday: 'tuesday',
  wednesday: 'wednesday',
  thursday: 'thursday',
  friday: 'friday',
  saturday: 'saturday',
  sun: 'Sun',
  mon: 'Mon',
  tues: 'Tue',
  wed: 'Wed',
  thurs: 'Thurs',
  fri: 'Fri',
  sat: 'Sat',
  scheduleTime: 'Schedule Your Time',
  availSlots: 'available slots',
  noAvailSlots: 'no available slots',
  slotsRemaining: 'slots remaining',
  greaterQuantity:
    'Quantity selected is greater than available slots. Please decrease the quantity or choose another slot',
  selectedStartDate: 'Selected start date',
  date: 'Start Date',
  chooseTeamMember: 'Choose a Team Member',
  appointmentName: 'Appointment Name',
  appointmentTime: 'Appointment Time',
  quantity: 'Quantity',
  contactOwner: 'Please contact the store owner for any questions or queries',
  bookingStart: 'Booking Start Date',
  bookingEnd: 'Booking End Date',
  selectedTime: 'Selected Time',
  selectedDates: 'Selected Dates',
  confirmTime: 'Confirm Time',
  enterPhoneNumber:
    'Enter your phone number (This is required for sending text confirmations)',
  requiredFields: 'Please enter the required fields (Fields marked with *)',
  validEmail:
    "Please enter a valid email address, make sure you don't have any spaces or extra text in the email field",
  location: 'Location',
  googleMeet: 'Google Meet. Link will be sent after purchase',
  zoom: 'Zoom Meeting. Link will be sent after purchase',
  selectionRulesDesc:
    'Please select the date range based on selection rules. For choosing just one day double click on the date selected',
  loadingCalendar: 'Loading Calendar',
  oneTimePurchase: 'One Time Purchase',
  each: 'each',
  bookingsCount: 'bookings with this purchase',
  purchaseOptions: 'Purchase Options',
  selectionRules: 'Selection Rules',
  minDays: 'Minimum Days',
  maxDays: 'Maximum Days',
  selectCorrectRules: 'Select dates based on selection rules',
  datesSelected: 'Dates Selected',
  startDate: 'Start Date',
  endDate: 'End Date',
  noAvailabilityThisMonth: 'No Availability this Month',
  checkNextMonth: 'Next Month',
  discountText: 'Save',
  timezone: 'Timezone',
  duration: 'Duration',
  previousSelectedTime: 'Previous Selected Time',
  customerName: 'Customer Name',
  customerEmail: 'Customer Email',
  teamMemberName: 'Team member name',
  cancellationReason: 'Cancellation Reason',
  cancelAppointment: 'Cancel Appointment',
  success: 'SUCCESS',
  appointmentCancelled: 'The appointment has been cancelled.',
  cancelReason: 'Reason for cancel',
  rescheduleReason: 'Reason for reschedule',
  additonalInfo:
    'Booking will be confirmed after selecting time and purchasing slots',
  waitList: 'Waitlist Slot',
  emailSentToAddress: 'An email has been sent to the email address',
}

export const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THUR', 'FRI', 'SAT']

export const variablesList = [
  {
    key: '{{product_name}}',
    value: 'Product Name',
  },
  {
    key: '{{product_price}}',
    value: 'Product price',
  },
  {
    key: '{{product_variant}}',
    value: 'Variant Name',
  },
  {
    key: '{{appointment_time}}',
    value: 'Service Time',
  },
  {
    key: '{{duration}}',
    value: 'Service duration',
  },
  {
    key: '{{meeting_detail}}',
    value: 'Optional Field Meeting Details',
  },
  {
    key: '{{note}}',
    value: 'Optional Field Note',
  },
  {
    key: '{{customer_name}}',
    value: 'Customer Name',
  },
  {
    key: '{{customer_email}}',
    value: 'Customer Email',
  },
  {
    key: '{{customer_phone}}',
    value: 'Customer Phone',
  },
  {
    key: '{{team_member_name}}',
    value: 'Team Member Name',
  },
  {
    key: '{{shipping_address}}',
    value: 'Shipping Address',
  },
  {
    key: '{{billing_address}}',
    value: 'Billing Address',
  },
  {
    key: '{{checkout_note}}',
    value: 'Checkout Note',
  },
  {
    key: '{{order_name}}',
    value: 'Shopify Order Name Show in Admin',
  },
  {
    key: '{{order_id}}',
    value: 'Internal Shopify Order Id',
  },
  {
    key: '{{location}}',
    value: 'Location',
  },
  {
    key: '{{reschedule_link}}',
    value: 'Rescheduling link',
  },
  {
    key: '{{cancel_link}}',
    value: 'Cancellation link',
  },
  {
    key: '{{customer_portal_link}}',
    value: 'Customer Portal Link',
  },
  {
    key: '{{reconfirm_status_url}}',
    value: 'Reconfirm Booking URL',
  },
  {
    key: '{{custom_fields}}',
    value: 'Custom Fields',
  },
  {
    key: '{{group_count}}',
    value: 'Group Count',
  },
]

export const subscriptionVariable = [
  {
    key: '{{subscription_contract_uuid}}',
    value: 'Unique Id of Subscription Contract',
  },
  {
    key: '{{subscription_contract_status}}',
    value: 'Subscription Contract Status',
  },
  {
    key: '{{product_variant}}',
    value: 'Product Variant',
  },
  {
    key: '{{product_name}}',
    value: 'Product Name',
  },
  {
    key: '{{customer_email}}',
    value: 'Customer Email',
  },
  {
    key: '{{customer_portal_link}}',
    value: 'Customer Portal Link',
  },
  {
    key: '{{max_booking_count}}',
    value: 'Max Booking Count',
  },
  {
    key: '{{current_booking_count}}',
    value: 'Current booking Count',
  },
  {
    key: '{{subscription_type}}',
    value: 'Subscription Type(recurring or fixed)',
  },
]
export const calendarVariablesList = {
  single: [
    {
      key: '{{product_name}}',
      value: 'Product Name',
    },
    {
      key: '{{product_variant}}',
      value: 'Variant Name',
    },
    {
      key: '{{appointment_time}}',
      value: 'Service Time',
    },
    {
      key: '{{duration}}',
      value: 'Service Duration',
    },
    {
      key: '{{meeting_detail}}',
      value: 'Optional Field Meeting Details',
    },
    {
      key: '{{note}}',
      value: 'Optional Field Note',
    },
    {
      key: '{{customer_name}}',
      value: 'Customer Name',
    },
    {
      key: '{{customer_email}}',
      value: 'Customer Email',
    },
    {
      key: '{{phone_num}}',
      value: 'Customer Phone Number',
    },
    {
      key: '{{team_member_name}}',
      value: 'Team Member Name',
    },
    {
      key: '{{shipping_address}}',
      value: 'Shipping Address',
    },
    {
      key: '{{location}}',
      value: 'Location',
    },
    {
      key: '{{note}}',
      value: 'Note',
    },
    {
      key: '{{order_name}}',
      value: 'Order Name',
    },
    {
      key: '{{reschedule_link}}',
      value: 'Rescheduling Link (Empty if not present)',
    },
    {
      key: '{{cancellation_link}}',
      value: 'Cancellatio Link (Empty if not present)',
    },
    {
      key: '{{custom_questions}}',
      value: 'Custom Questions (Empty if not present)',
    },
    {
      key: '{{group}}',
      value: 'Tags (Empty if not present)',
    },
    {
      key: '{{order_name}}',
      value: 'Order Name',
    },
    {
      key: '{{quantity}}',
      value: 'Group Count',
    },
    {
      key: '{{product_price}}',
      value: 'Product Price',
    },
  ],
  group: [
    {
      key: '{{product_name}}',
      value: 'Product Name',
    },
    {
      key: '{{product_variant}}',
      value: 'Variant Name',
    },
    {
      key: '{{appointment_time}}',
      value: 'Service Time',
    },
    {
      key: '{{duration}}',
      value: 'Service Duration',
    },
    {
      key: '{{meeting_detail}}',
      value: 'Optional Field Meeting Details',
    },
    {
      key: '{{note}}',
      value: 'Optional Field Note',
    },
    {
      key: '{{team_member_name}}',
      value: 'Team Member Name',
    },
    {
      key: '{{shipping_address}}',
      value: 'Shipping Address',
    },
    {
      key: '{{order_name}}',
      value: 'Order Name',
    },
    {
      key: '{{location}}',
      value: 'Location',
    },
    {
      key: '{{group}}',
      value: 'Tags (Empty if not present)',
    },
    {
      key: '{{order_name}}',
      value: 'Order Name',
    },
    {
      key: '{{quantity}}',
      value: 'Group Count',
    },
    {
      key: '{{product_price}}',
      value: 'Product Price',
    },
  ],
}

export const textVariablesList = [
  {
    key: '{{product_name}}',
    value: 'Product Name',
  },
  {
    key: '{{product_variant}}',
    value: 'Variant Name',
  },
  {
    key: '{{appointment_time}}',
    value: 'Service Time',
  },
  {
    key: '{{duration}}',
    value: 'Service Duration',
  },
  {
    key: '{{meeting_detail}}',
    value: 'Optional Field Meeting Details',
  },
  {
    key: '{{note}}',
    value: 'Optional Field Note',
  },
  {
    key: '{{customer_name}}',
    value: 'Customer Name',
  },
  {
    key: '{{customer_email}}',
    value: 'Customer Email',
  },
  {
    key: '{{team_member_name}}',
    value: 'Team Member Name',
  },
  {
    key: '{{quantity}}',
    value: 'Quantity',
  },
  {
    key: '{{location}}',
    value: 'Location',
  },
]

export const formatShippingAddres = (shipping_address) => {
  if (!shipping_address) {
    return ''
  }

  let address = ''
  if (!!shipping_address.address1) {
    address += shipping_address.address1
  }

  if (!!shipping_address.address2) {
    address += ', ' + shipping_address.address2
  }

  if (!!shipping_address.city) {
    address += ', ' + shipping_address.city
  }

  if (!!shipping_address.zip) {
    address += ', ' + shipping_address.zip
  }
  return address
}

export const planMap = {
  pro: 'Pro Plan',
  premium: 'Premium Plan',
  enterprise: 'Enterprise Plan',
  teams: 'Teams Plan',
  free_forever: 'Free Forever',
  free_forever_1: 'Free Forever',
  free: 'Free',
  advanced: 'Advanced Plan',
}

export const calendarColors = [
  '#0A1931',
  '#5F939A',
  '#343A40',
  '#524646',
  '#99154E',
  '#480032',
  '#F55C47',
  '#efc035',
  '#ff9f44',
  '#999B84',
  '#325288',
  '#1F441E',
  '#693C72',
  '#351F39',
  '#295939',
  '#C62A88',
  '#1AA6B7',
  '#9A1F40',
  '#9F1E49',
  '#B2085D',
  '#FB9300',
  '#A0937D',
  '#EEB76B',
  '#536162',
]

export const configFields = [
  { label: 'Duration', values: ['duration'] },
  {
    label: 'Date Range',
    values: [
      'date_range_type',
      'days_in_future',
      'start_date_range',
      'end_date_range',
    ],
  },
  { label: 'Timezone', values: ['timezone'] },
  {
    label: 'Member Allocation & Assignement Rule',
    values: ['teamMembers', 'tm_assign_rule'],
  },
  {
    label: 'Location',
    values: ['location_type', 'location_value'],
  },
  { label: 'Meeting Details', values: ['meeting_detail'] },
  { label: 'Note', values: ['note'] },
  {
    label: 'Group Appointments',
    values: ['max_capacity', 'rem_group_slot_after_booking'],
  },
  {
    label: 'Send Email Reminder',
    values: ['send_reminder', 'reminder_duration'],
  },
  {
    label: 'Send Text Reminder',
    values: ['send_text_reminder', 'text_duration'],
  },
  {
    label: 'Send Whatsapp Reminder',
    values: ['send_whatsapp_reminder', 'whatsapp_duration'],
  },
  {
    label: 'Allow Customers To Reschedule Booking',
    values: ['allow_reschedule', 'reschedule_duration'],
  },
  {
    label: 'Allow Customers To Cancel Booking',
    values: ['allow_cancel', 'cancel_duration'],
  },
  {
    label: 'Allow Waitlist after slots are filled',
    values: ['allow_waitlist'],
  },
  {
    label: 'Business/Custom Hours Toggle',
    values: ['use_global_availability'],
  },
  { label: 'Set your weekly hours', values: ['weeklyHours'] },
  { label: 'Add date overrides', values: ['override'] },
  { label: 'Scheduling Cutoff', values: ['minimum_notice'] },
  {
    label: 'Time Increments',
    values: ['interval'],
  },
  {
    label: 'Max Events',
    values: ['enable_max_events_per_day', 'max_events_per_day'],
  },
  {
    label: 'Skip Payment Questions',
    values: ['email_label', 'name_label', 'phone_label', 'show_phone'],
  },
  {
    label: 'Add Preparation Time',
    values: ['start_buffer_time'],
  },
  { label: 'Add Time After Booking', values: ['end_buffer_time'] },
  { label: 'Minimum selection days', values: ['min_day_duration'] },
  { label: 'Maximum selection days', values: ['max_day_duration'] },
  { label: 'Add Ons', values: ['addOns'] },
  { label: 'Fix Quantity', values: ['fixed_multi_day_price'] },
  { label: 'Internal Calendar Color', values: ['color'] },
  { label: 'Date/Month Start', values: ['start_month'] },
]

var isSafari =
  /constructor/i.test(window.HTMLElement) ||
  (function (p) {
    return p.toString() === '[object SafariRemoteNotification]'
  })(
    !window['safari'] ||
      (typeof safari !== 'undefined' && window['safari'].pushNotification)
  )
function iOS() {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

export const isApple = isSafari || iOS()

export const isPremiumPlus = (plan) => {
  return (
    plan === 'premium' ||
    plan === 'enterprise' ||
    plan === 'teams' ||
    plan === 'free_forever' ||
    plan === 'free_forever_1' ||
    plan === 'advanced'
  )
}

export const isProPlus = (plan) => {
  return (
    plan === 'pro' ||
    plan === 'premium' ||
    plan === 'enterprise' ||
    plan === 'teams' ||
    plan === 'free_forever' ||
    plan === 'free_forever_1' ||
    plan === 'advanced'
  )
}

export const isEnterprisePlus = (plan) => {
  return plan === 'enterprise' || plan === 'teams' || plan === 'free_forever'
}

export const isAdvancedPlus = (plan) => {
  return (
    plan === 'enterprise' ||
    plan === 'teams' ||
    plan === 'free_forever' ||
    plan === 'advanced'
  )
}

export const isPaidUsageFlow = (plan, flow) => {
  if (flow === 'usage_v1') {
    return plan === 'pro'
  }
  return false
}

export const isUsageFlow = (flow) => {
  return flow === 'usage_v1'
}

export const checkRequiredPlan = (requiredPlan, actualPlan) => {
  if (requiredPlan === 'premium') {
    return isPremiumPlus(actualPlan)
  } else if (requiredPlan === 'pro') {
    return isProPlus(actualPlan)
  } else if (requiredPlan === 'enterprise') {
    return isEnterprisePlus(actualPlan)
  } else if (requiredPlan === 'advanced') {
    return isAdvancedPlus(actualPlan)
  }
}

export const generateDateRange = () => {
  let startDate = '2024-10-01'
  let endDate = '2027-01-01'
  var start = startDate.split('-')
  var end = endDate.split('-')
  var startYear = parseInt(start[0])
  var endYear = parseInt(end[0])
  var dates = []

  for (var i = startYear; i <= endYear; i++) {
    var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1
    var startMon = i === startYear ? parseInt(start[1]) - 1 : 0
    for (var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j + 1) {
      var month = j + 1
      var displayMonth = month < 10 ? '0' + month : month
      dates.push([i, displayMonth].join('-'))
    }
  }
  return dates.map((d) => ({ label: d, value: d }))
}

export const phoneOptions = [
  { label: '', value: null },
  { value: 1, label: 'US/CA (+1)' },
  { value: 49, label: 'DE (+49)' },
  { value: 93, label: 'AF (+93)' },
  { value: 355, label: 'AL (+355)' },
  { value: 213, label: 'DZ (+213)' },
  { value: 1684, label: 'AS (+1684)' },
  { value: 376, label: 'AD (+376)' },
  { value: 244, label: 'AO (+244)' },
  { value: 1264, label: 'AI (+1264)' },
  { value: 672, label: 'AQ (+672)' },
  { value: 1268, label: 'Antigua and Barbuda (+1268)' },
  { value: 54, label: 'AR (+54)' },
  { value: 374, label: 'AM (+374)' },
  { value: 297, label: 'AW (+297)' },
  { value: 61, label: 'AU (+61)' },
  { value: 43, label: 'AT (+43)' },
  { value: 994, label: 'AZ (+994)' },
  { value: 1242, label: 'BS (+1242)' },
  { value: 973, label: 'BH (+973)' },
  { value: 880, label: 'BD (+880)' },
  { value: 1246, label: 'BB (+1246)' },
  { value: 375, label: 'BY (+375)' },
  { value: 32, label: 'BE (+32)' },
  { value: 501, label: 'BZ (+501)' },
  { value: 229, label: 'BJ (+229)' },
  { value: 1441, label: 'BM (+1441)' },
  { value: 975, label: 'BT (+975)' },
  { value: 591, label: 'BO (+591)' },
  { value: 387, label: 'Bosnia and Herzegovina (+387)' },
  { value: 267, label: 'BW (+267)' },
  { value: 55, label: 'BR (+55)' },
  { value: 246, label: 'IO (+246)' },
  { value: 1284, label: 'British Virgin Islands (+1284)' },
  { value: 673, label: 'Brunei (+673)' },
  { value: 359, label: 'BG (+359)' },
  { value: 226, label: 'BF (+226)' },
  { value: 257, label: 'BI (+257)' },
  { value: 855, label: 'KH (+855)' },
  { value: 237, label: 'CM (+237)' },
  { value: 238, label: 'CV (+238)' },
  { value: 1345, label: 'KY (+1345)' },
  { value: 236, label: 'CF (+236)' },
  { value: 235, label: 'TD (+235)' },
  { value: 56, label: 'CL (+56)' },
  { value: 86, label: 'CN (+86)' },
  { value: 61, label: 'CX (+61)' },
  { value: 61, label: 'Cocos Islands (+61)' },
  { value: 57, label: 'CO (+57)' },
  { value: 269, label: 'KM (+269)' },
  { value: 682, label: 'CK (+682)' },
  { value: 506, label: 'CR (+506)' },
  { value: 385, label: 'HR (+385)' },
  { value: 53, label: 'CU (+53)' },
  { value: 599, label: 'Curacao (+599)' },
  { value: 357, label: 'CY (+357)' },
  { value: 420, label: 'CZ (+420)' },
  { value: 243, label: 'Democratic Republic of the CG (+243)' },
  { value: 45, label: 'DK (+45)' },
  { value: 253, label: 'DJ (+253)' },
  { value: 1767, label: 'DM (+1767)' },
  { value: 1809, label: 'DMn Republic (+1809)' },
  { value: 670, label: 'East Timor (+670)' },
  { value: 593, label: 'EC (+593)' },
  { value: 20, label: 'EG (+20)' },
  { value: 503, label: 'SV (+503)' },
  { value: 240, label: 'GQ (+240)' },
  { value: 291, label: 'ER (+291)' },
  { value: 372, label: 'EE (+372)' },
  { value: 251, label: 'ET (+251)' },
  { value: 500, label: 'Falkland Islands (+500)' },
  { value: 298, label: 'FO (+298)' },
  { value: 679, label: 'FJ (+679)' },
  { value: 358, label: 'FI (+358)' },
  { value: 33, label: 'FR (+33)' },
  { value: 689, label: 'PF (+689)' },
  { value: 241, label: 'GA (+241)' },
  { value: 220, label: 'GM (+220)' },
  { value: 995, label: 'GE (+995)' },
  { value: 233, label: 'GH (+233)' },
  { value: 350, label: 'GI (+350)' },
  { value: 30, label: 'GR (+30)' },
  { value: 299, label: 'GL (+299)' },
  { value: 1473, label: 'GD (+1473)' },
  { value: 1671, label: 'GU (+1671)' },
  { value: 502, label: 'GT (+502)' },
  { value: 44 - 1481, label: 'GG (+44-1481)' },
  { value: 224, label: 'GN (+224)' },
  { value: 245, label: 'GN-Bissau (+245)' },
  { value: 592, label: 'GY (+592)' },
  { value: 509, label: 'HT (+509)' },
  { value: 504, label: 'HN (+504)' },
  { value: 852, label: 'HK (+852)' },
  { value: 36, label: 'HU (+36)' },
  { value: 354, label: 'IS (+354)' },
  { value: 91, label: 'IN (+91)' },
  { value: 62, label: 'ID (+62)' },
  { value: 98, label: 'Iran (+98)' },
  { value: 964, label: 'IQ (+964)' },
  { value: 353, label: 'IE (+353)' },
  { value: 44 - 1624, label: 'Isle of Man (+44-1624)' },
  { value: 972, label: 'IL (+972)' },
  { value: 39, label: 'IT (+39)' },
  { value: 225, label: 'Ivory Coast (+225)' },
  { value: 1876, label: 'JM (+1876)' },
  { value: 81, label: 'JP (+81)' },
  { value: 44 - 1534, label: 'JE (+44-1534)' },
  { value: 962, label: 'JO (+962)' },
  { value: 7, label: 'KZ (+7)' },
  { value: 254, label: 'KE (+254)' },
  { value: 686, label: 'KI (+686)' },
  { value: 383, label: 'Kosovo (+383)' },
  { value: 965, label: 'KW (+965)' },
  { value: 996, label: 'KG (+996)' },
  { value: 856, label: 'Laos (+856)' },
  { value: 371, label: 'LV (+371)' },
  { value: 961, label: 'LB (+961)' },
  { value: 266, label: 'LS (+266)' },
  { value: 231, label: 'LR (+231)' },
  { value: 218, label: 'Libya (+218)' },
  { value: 423, label: 'LI (+423)' },
  { value: 370, label: 'LT (+370)' },
  { value: 352, label: 'LU (+352)' },
  { value: 853, label: 'Macau (+853)' },
  { value: 389, label: 'MK (+389)' },
  { value: 261, label: 'MG (+261)' },
  { value: 265, label: 'MW (+265)' },
  { value: 60, label: 'MY (+60)' },
  { value: 960, label: 'MV (+960)' },
  { value: 223, label: 'ML (+223)' },
  { value: 356, label: 'MT (+356)' },
  { value: 692, label: 'MH (+692)' },
  { value: 222, label: 'MR (+222)' },
  { value: 230, label: 'MU (+230)' },
  { value: 262, label: 'YT (+262)' },
  { value: 52, label: 'MX (+52)' },
  { value: 691, label: 'Micronesia (+691)' },
  { value: 373, label: 'MD (+373)' },
  { value: 377, label: 'MC (+377)' },
  { value: 976, label: 'MN (+976)' },
  { value: 382, label: 'ME (+382)' },
  { value: 1664, label: 'MS (+1664)' },
  { value: 212, label: 'MA (+212)' },
  { value: 258, label: 'MZ (+258)' },
  { value: 95, label: 'MM (+95)' },
  { value: 264, label: 'NA (+264)' },
  { value: 674, label: 'NR (+674)' },
  { value: 977, label: 'NP (+977)' },
  { value: 31, label: 'NL (+31)' },
  { value: 599, label: 'NL Antilles (+599)' },
  { value: 687, label: 'NC (+687)' },
  { value: 64, label: 'NZ (+64)' },
  { value: 505, label: 'NI (+505)' },
  { value: 227, label: 'NE (+227)' },
  { value: 234, label: 'NEia (+234)' },
  { value: 683, label: 'NU (+683)' },
  { value: 850, label: 'North KR (+850)' },
  { value: 1670, label: 'MP (+1670)' },
  { value: 47, label: 'NO (+47)' },
  { value: 968, label: 'OM (+968)' },
  { value: 92, label: 'PK (+92)' },
  { value: 680, label: 'PW (+680)' },
  { value: 970, label: 'Palestine (+970)' },
  { value: 507, label: 'PA (+507)' },
  { value: 675, label: 'Papua New GN (+675)' },
  { value: 595, label: 'PY (+595)' },
  { value: 51, label: 'PE (+51)' },
  { value: 63, label: 'PH (+63)' },
  { value: 64, label: 'PN (+64)' },
  { value: 48, label: 'PL (+48)' },
  { value: 351, label: 'PT (+351)' },
  { value: 1787, label: 'PR (+1787)' },
  { value: 974, label: 'QA (+974)' },
  { value: 242, label: 'Republic of the CG (+242)' },
  { value: 262, label: 'RE (+262)' },
  { value: 40, label: 'RO (+40)' },
  { value: 7, label: 'Russia (+7)' },
  { value: 250, label: 'RW (+250)' },
  { value: 590, label: 'BL (+590)' },
  { value: 290, label: 'SH (+290)' },
  { value: 1869, label: 'Saint Kitts and Nevis (+1869)' },
  { value: 1758, label: 'LC (+1758)' },
  { value: 590, label: 'MF (+590)' },
  { value: 508, label: 'Saint Pierre and Miquelon (+508)' },
  { value: 1784, label: 'Saint Vincent and the Grenadines (+1784)' },
  { value: 685, label: 'WS (+685)' },
  { value: 378, label: 'SM (+378)' },
  { value: 239, label: 'Sao Tome and Principe (+239)' },
  { value: 966, label: 'SA (+966)' },
  { value: 221, label: 'SN (+221)' },
  { value: 381, label: 'RS (+381)' },
  { value: 248, label: 'SC (+248)' },
  { value: 232, label: 'SL (+232)' },
  { value: 65, label: 'SG (+65)' },
  { value: 1721, label: 'Sint Maarten (+1721)' },
  { value: 421, label: 'SK (+421)' },
  { value: 386, label: 'SI (+386)' },
  { value: 677, label: 'SB (+677)' },
  { value: 252, label: 'SO (+252)' },
  { value: 27, label: 'ZA (+27)' },
  { value: 82, label: 'South KR (+82)' },
  { value: 211, label: 'South SD (+211)' },
  { value: 34, label: 'ES (+34)' },
  { value: 94, label: 'LK (+94)' },
  { value: 249, label: 'SD (+249)' },
  { value: 597, label: 'SR (+597)' },
  { value: 47, label: 'Svalbard and Jan Mayen (+47)' },
  { value: 268, label: 'SZ (+268)' },
  { value: 46, label: 'SE (+46)' },
  { value: 41, label: 'CH (+41)' },
  { value: 963, label: 'Syria (+963)' },
  { value: 886, label: 'TW (+886)' },
  { value: 992, label: 'TJ (+992)' },
  { value: 255, label: 'TZ (+255)' },
  { value: 66, label: 'TH (+66)' },
  { value: 228, label: 'TG (+228)' },
  { value: 690, label: 'TK (+690)' },
  { value: 676, label: 'TO (+676)' },
  { value: 1868, label: 'Trinidad and Tobago (+1868)' },
  { value: 216, label: 'TN (+216)' },
  { value: 90, label: 'TR (+90)' },
  { value: 993, label: 'TM (+993)' },
  { value: 1649, label: 'Turks and Caicos Islands (+1649)' },
  { value: 688, label: 'TV (+688)' },
  { value: 1340, label: 'U.S. Virgin Islands (+1340)' },
  { value: 256, label: 'UG (+256)' },
  { value: 380, label: 'UA (+380)' },
  { value: 971, label: 'AE (+971)' },
  { value: 44, label: 'GB (+44)' },
  { value: 598, label: 'UY (+598)' },
  { value: 998, label: 'UZ (+998)' },
  { value: 678, label: 'VU (+678)' },
  { value: 379, label: 'Vatican (+379)' },
  { value: 58, label: 'VE (+58)' },
  { value: 84, label: 'Vietnam (+84)' },
  { value: 212, label: 'EH (+212)' },
  { value: 967, label: 'YE (+967)' },
  { value: 260, label: 'ZM (+260)' },
  { value: 263, label: 'ZW (+263)' },
]

export const appointmentHeaders = [
  { label: 'Service Name', key: 'variant_name' },
  { label: 'Duration (in mins)', key: 'duration' },
  { label: 'Invitees can schedule', key: 'invitees_schedule' },
  { label: 'Timezone', key: 'timezone' },
  { label: 'Assigned Members', key: 'assigned_members' },
  { label: 'Assignment Rules', key: 'assignment_rules' },
  { label: 'Note', key: 'note' },
  { label: 'Weekly Hours', key: 'weekly_hours' },
  { label: 'Location Type', key: 'location_type' },
  { label: 'Location Value', key: 'location_value' },
  {
    label: 'Invitees_can"t schedule within (in mins)',
    key: 'invitees_cant_schedule',
  },
  { label: 'Increments', key: 'increments' },
  { label: 'Is combo service', key: 'combo_service' },
  { label: 'Start Buffer Time (in mins)', key: 'start_buffer_time' },
  { label: 'End Buffer Time (in mins)', key: 'end_buffer_time' },
  { label: 'Workflows', key: 'workflows' },
]

export const isMobileOrTablet = () => {
  let check = false
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

export const logsMap = {
  online_booking_confirmed: {
    header: 'Booking Confirmed (Online Store)',
    body: 'Booking with {{customer_email}} was confirmed.',
  },
  manual_booking_confirmed: {
    header: 'Booking Confirmed (Manual Booking)',
    body: 'Booking with {{customer_email}} was confirmed.',
  },
  skip_pay_booking_confirmed: {
    header: 'Booking Confirmed (Skip Payment)',
    body: 'Booking with {{customer_email}} was confirmed.',
  },
  admin_confirmation_email: {
    header: 'Confirmation Email Sent (Admin)',
    body: 'Confirmation email was sent successfully to {{sender_mail}}.',
  },
  team_member_confirmation_email: {
    header: 'Confirmation Email Sent (Team Member)',
    body: 'Confirmation email was sent successfully to {{sender_mail}}.',
  },
  customer_confirmation_email: {
    header: 'Confirmation Email Sent (Customer)',
    body: 'Confirmation email was sent successfully to {{sender_mail}}.',
  },
  admin_rescheduling_email: {
    header: 'Rescheduling Email Sent (Admin)',
    body: 'Rescheduling email was sent successfully to {{sender_mail}}.',
  },
  team_member_rescheduling_email: {
    header: 'Rescheduling Email Sent (Team Member)',
    body: 'Rescheduling email was sent successfully to {{sender_mail}}.',
  },
  customer_rescheduling_email: {
    header: 'Rescheduling Email Sent (Customer)',
    body: 'Rescheduling email was sent successfully to {{sender_mail}}.',
  },
  admin_reminder_email: {
    header: 'Reminder Email Sent (Admin)',
    body: 'Reminder email was sent successfully to {{sender_mail}}.',
  },
  team_member_reminder_email: {
    header: 'Reminder Email Sent (Team Member)',
    body: 'Reminder email was sent successfully to {{sender_mail}}.',
  },
  customer_reminder_email: {
    header: 'Reminder Email Sent (Customer)',
    body: 'Reminder email was sent successfully to {{sender_mail}}.',
  },
  admin_confirmation_text: {
    header: 'Confirmation Text Sent (Admin)',
    body: 'Confirmation text was sent successfully to {{phone_number}}.',
  },
  team_member_confirmation_text: {
    header: 'Confirmation Text Sent (Team Member)',
    body: 'Confirmation text was sent successfully to  {{phone_number}}.',
  },
  customer_confirmation_text: {
    header: 'Confirmation Text Sent (Customer)',
    body: 'Confirmation text was sent successfully to {{phone_number}}.',
  },
  admin_rescheduling_text: {
    header: 'Rescheduling Text Sent (Admim)',
    body: 'Rescheduling text was sent successfully to {{phone_number}}.',
  },
  team_member_rescheduling_text: {
    header: 'Rescheduling Text Sent (Team Member)',
    body: 'Rescheduling text was sent successfully to {{phone_number}}.',
  },
  customer_rescheduling_text: {
    header: 'Rescheduling Text Sent (Customer)',
    body: 'Rescheduling text was sent successfully to {{phone_number}}.',
  },
  admin_reminder_text: {
    header: 'Reminder Text Sent (Admin)',
    body: 'Reminder text was sent successfully to {{phone_number}}.',
  },
  team_member_reminder_text: {
    header: 'Reminder Text Sent (Team Member)',
    body: 'Reminder text was sent successfully to {{phone_number}}.',
  },
  customer_reminder_text: {
    header: 'Reminder Text Sent (Customer)',
    body: 'Reminder text was sent successfully to {{phone_number}}.',
  },
  admin_confirmation_whatsapp: {
    header: 'Confirmation Whatsapp Sent (Admin)',
    body: 'Confirmation whatsapp was sent successfully to {{phone_number}}.',
  },
  team_member_confirmation_whatsapp: {
    header: 'Confirmation Whatsapp Sent (Team Member)',
    body: 'Confirmation whatsapp was sent successfully to {{phone_number}}.',
  },
  customer_confirmation_whatsapp: {
    header: 'Confirmation Whatsapp Sent (Customer)',
    body: 'Confirmation whatsapp was sent successfully to {{phone_number}}.',
  },
  admin_rescheduling_whatsapp: {
    header: 'Rescheduling Whatsapp Sent (Admin)',
    body: 'Rescheduling whatsapp was sent successfully to {{phone_number}}.',
  },
  team_member_rescheduling_whatsapp: {
    header: 'Rescheduling Whatsapp Sent (Team Member)',
    body: 'Rescheduling whatsapp was sent successfully to {{phone_number}}.',
  },
  customer_rescheduling_whatsapp: {
    header: 'Rescheduling Whatsapp Sent (Customer)',
    body: 'Rescheduling whatsapp was sent successfully to {{phone_number}}.',
  },
  admin_reminder_whatsapp: {
    header: 'Reminder Whatsapp Sent (Admin)',
    body: 'Reminder Whatsapp was sent successfully to {{phone_number}}.',
  },
  team_member_reminder_whatsapp: {
    header: 'Reminder Whatsapp Sent (Team Member)',
    body: 'Reminder Whatsapp was sent successfully to {{phone_number}}.',
  },
  customer_reminder_whatsapp: {
    header: 'Reminder Whatsapp Sent (Customer)',
    body: 'Reminder Whatsapp was sent successfully to {{phone_number}}.',
  },
  booking_cancelled_by_admin: {
    header: 'Booking Cancelled By Admin',
    body: 'Booking was cancelled by admin.',
  },
  booking_cancelled_by_team_member: {
    header: 'Booking Cancelled By Team member',
    body: 'Booking was cancelled by Team member.',
  },
  booking_cancelled_by_customer: {
    header: 'Booking Cancelled By Customer',
    body: 'Booking was cancelled by customer.',
  },
  booking_team_member_reassigned: {
    header: 'Booking Team member reassigned',
    body: 'Booking was reassigned from {{previous_team_member}} to  {{team_member_name}}.',
  },
  booking_service_reassigned: {
    header: 'Booking Service reassigned',
    body: 'Booking service was reassigned from {{previous_service}}.',
  },
  calendar_confirmed: {
    header: 'Calendar Event Added',
    body: 'Event was added to the calendar link: {{calendar_url}}.',
  },
  calendar_error: {
    header: 'Calendar Error',
    body: 'Event was not added to the calendar due to an error.',
  },
  calendar_update: {
    header: 'Calendar Updated',
    body: 'Event was updated in the calendar link: {{calendar_url}}.',
  },
  booking_rescheduled_by_admin: {
    header: 'Booking Rescheduled By Admin',
    body: 'Booking was rescheduled by Admin.',
  },
  booking_rescheduled_by_team_member: {
    header: 'Booking Rescheduled By Team member',
    body: 'Booking was rescheduled by Team member.',
  },
  booking_rescheduled_by_customer: {
    header: 'Booking Rescheduled By Customer',
    body: 'Booking was rescheduled by Customer.',
  },
  booking_google_meet_error: {
    header: 'Google meet error',
    body: 'Google meet link was not created due to an error.',
  },
  zoom_confirmed: {
    header: 'Zoom link confirmed',
    body: 'Zoom link was created with link: {{location_url}}.',
  },
  zoom_error: {
    header: 'Zoom error',
    body: 'Zoom link was not created due to an error.',
  },
  booking_google_meet: {
    header: 'Google meet confirmed',
    body: 'Google meet link was created with link: {{location_url}}.',
  },
  manual_email: {
    header: 'Manual email sent',
    body: 'Manual email was sent to the customer with email {{sender_mail}}.',
  },
  booking_status_changed: {
    header: 'Booking Status Changed',
    body: 'Booking status was changed from {{previous_status}} to {{new_status}} by admin.',
  },
}

export function setString(key, value) {
  window.sessionStorage.setItem(key, value)
}

export function getString(key) {
  return window.sessionStorage.getItem(key)
}

export function removeItem(key) {
  window.sessionStorage.removeItem(key)
}

export const subStores = []

export function getStats(slot, style = '') {
  return typeof slot.customers_count === 'number' &&
    slot.max_capacity > 1 &&
    !slot.is_group_apt ? (
    <div
      style={{
        color: '#868383',
        fontSize: '13px',
        position: 'relative',
        top: '-4px',
        textAlign: 'center',
        ...style,
      }}
    >
      {slot.max_capacity - slot.customers_count}/{slot.max_capacity} slots
      remaining
    </div>
  ) : null
}

export const TrackEvent = (eventName, properties) => {
  if (window.isShopifyMainAdmin) {
    posthog.capture(eventName, properties)
    if (!!window.mantleTrack) {
      window.mantleTrack.track(eventName, properties)
    }
  }
}

export const AWS_URL =
  'https://appointment-booking-shopify.s3.ap-south-1.amazonaws.com'

export const CANCELLED_SCENARIO = {
  booking_cancelled_by_admin: 'Admin',
  booking_cancelled_by_team_member: 'Team Member',
  booking_cancelled_by_customer: 'Customer',
}

export const capitalizeFirstLetter = (word) => {
  if (!word) return ''
  return word.charAt(0).toUpperCase() + word.slice(1)
}

export const multi_day_list = [
  'gatewayworkshopsvenuecourses.myshopify.com',
  'thriversity.myshopify.com',
  'drcarlosrosales.myshopify.com',
  'flickergifts.myshopify.com',
  '02a67f.myshopify.com',
  'ruffdog-sports.myshopify.com',
  'labambina-au.myshopify.com',
  '7642c5-2.myshopify.com',
  'project-mayhem-sailing.myshopify.com',
  'aire-base.myshopify.com',
  'souped-up.myshopify.com',
  'glwellness.myshopify.com',
  'der-ute.myshopify.com',
  'paddlershub-uae.myshopify.com',
  'info-17be.myshopify.com',
  '8a6c12-2.myshopify.com',
]
